import { ApiError } from "@/api/fetchApi";

export function errorText(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.status === 0 || error.status >= 500) {
      return "Something went wrong on our side. Try again in a moment.";
    }
    return error.message;
  }
  if (error instanceof TypeError) return "We couldn't reach WealthyPlanet. Check your connection.";
  if (error instanceof Error) return error.message;
  return "Something went wrong.";
}

/** An inline error card with an optional retry. */
export function ErrorPanel({
  error,
  title = "We couldn't load this",
  onRetry,
}: {
  error: unknown;
  title?: string;
  onRetry?: () => void;
}) {
  return (
    <div className="wp-error" role="alert" data-testid="error-panel">
      <b>{title}</b>
      <span>{errorText(error)}</span>
      {onRetry && (
        <button type="button" className="wp-btn" onClick={onRetry}>
          Try again
        </button>
      )}
    </div>
  );
}
